import { createStore, combineReducers } from "redux"

import { Platform } from "react-native"

import auth from "./app/containers/public/reducers/authentication"
import { persistStore, persistReducer } from 'redux-persist'

import { AsyncStorage } from 'react-native';

const rootReducer = combineReducers({ auth })

const persistConfig = {
    key: "root",
    storage: AsyncStorage
}

const persistedReducer = persistReducer(persistConfig, rootReducer)


export const store =  createStore(persistedReducer)
export const persistor = persistStore(store)